import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import "./App.css";
import About from "./components/About";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Resume from "./components/Resume";
import Sidebar from "./components/Sidebar";
import { AnimatePresence } from "framer-motion";

function App() {
  return (
    <div className="app">
      <div className="container app__container">
        <div className="row app__row">
          <div className="col-lg-3">
            <Sidebar />
          </div>
          <div className="col-lg-9">
            <div className="app__main">
              <Navbar />
              <AnimatePresence exitBeforeEnter>
                <Switch>
                  <Route exact path="/">
                    <About />
                  </Route>
                  <Route exact path="/resume">
                    <Resume />
                  </Route>
                  <Route exact path="/projects">
                    <Projects />
                  </Route>
                  <Route>
                    <Redirect to="/" />
                  </Route>
                </Switch>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
